import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

export enum StatusEnum {
  进行中 = 1,
  即将开始,
  结束,
}
// 聚合banner接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=38787184
export const banner_aggregation_page = createAsyncThunk(
  'polly_banner_aggregation_page',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<InitialStateType, 'progress_list' | 'uncoming_list' | 'end_list'>
      >
    >(
      // '/live/activity/farm_storehouse_info',
      '/live/room/banner_aggregation_page',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export enum subscribeEnum {
  订阅 = 0,
  取消订阅,
}
// 订阅、取消订阅活动 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2318851

export const subscribe_activity = createAsyncThunk(
  'banner_subscribe_activity',
  async (arg: {aid: number; kind: subscribeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/live/room/subscribe_activity',
      {
        ...arg,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
export interface InfoType {
  cover: string
  link: string
  st: number
  et: number
  activity_type: number
  activity_title: string
  activity_desc: string
  people_num: number
  count_down: number
  is_subscription?: boolean
  subscription_num?: number
  aid?: number
}
export const getBannerList = createAsyncThunk(
  'AggregateBanner/getBannerList',
  async (e, store: any) => {
    const resp = await http.post('/live/room/feed_banner_aggregation', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

interface InitialStateType {
  progress_list?: Array<InfoType>
  uncoming_list?: Array<InfoType>
  end_list?: Array<InfoType>
  list: Array<string>
}
const initialState: InitialStateType = {
  list: Array(4).fill(null),
}
export const AggregateBannerSlice = createSlice({
  name: 'AggregateBanner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBannerList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      // eslint-disable-next-line no-param-reassign
      state.list = state.list.map((item, index) =>
        data.list?.[index] ? data.list[index] : item
      )
    })

    builder.addCase(banner_aggregation_page.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default AggregateBannerSlice.reducer
